<template>
  <div class="thank-for-feedback-modal">
    <div class="thank-for-feedback-text">
      Your input helps us fix issues and improve your search experience.
    </div>
    <div class="thank-for-feedback-modal-actions">
      <MsgButton
        type="primary"
        :full-width="false"
        class="close-button"
        @click="emit('close')"
      >
        Close
      </MsgButton>
    </div>
  </div>
</template>

<script setup>
import MsgButton from "../../MsgUi/MsgButton.vue";
const emit = defineEmits(["close"]);
</script>

<style scoped>
.thank-for-feedback-text{color:var(--color-text-secondary);font-family:Inter;font-size:14px;font-weight:400;letter-spacing:.6px;line-height:18px;margin-top:12px}.thank-for-feedback-modal-actions{display:flex;justify-content:flex-end;margin-top:24px}
</style>
